module.exports = __webpack_public_path__ + "media/images/point/close-47a7e97282e6cbe0c88e519f3edf3e46.svg";